var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg500Error(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 810,
    height: 439,
    viewBox: "0 0 810 439",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1393",
    "data-name": "Rectangle 1393",
    width: 810,
    height: 439,
    transform: "translate(553 74)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00080d",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2517",
    "data-name": "Group 2517",
    transform: "translate(-555 -180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2514",
    "data-name": "Group 2514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_51",
    "data-name": "Mask Group 51",
    transform: "translate(2 106)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 379,
    cy: 257,
    rx: 379,
    ry: 257,
    transform: "translate(579 115)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_4173",
    "data-name": "Line 4173",
    y1: 118,
    transform: "translate(867.5 254)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4174",
    "data-name": "Line 4174",
    y2: 47,
    transform: "translate(1101.5 258.5)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4175",
    "data-name": "Line 4175",
    x1: 227,
    transform: "translate(874.5 258.5)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4172",
    "data-name": "Line 4172",
    x2: 181.212,
    transform: "translate(1010.584 490.17)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2512",
    "data-name": "Group 2512",
    transform: "translate(982.664 278.525)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68488",
    "data-name": "Path 68488",
    d: "M478.382,190.163v46.32a7.314,7.314,0,0,1-7.319,7.319h-93v-5.918c0-4.057-3.181,0-7.217,0H272.626c-4.036,0-7.4-4.057-7.4,0V243.8H248.162a7.327,7.327,0,0,1-7.319-7.319v-46.32a7.327,7.327,0,0,1,7.319-7.319h222.9A7.314,7.314,0,0,1,478.382,190.163Z",
    transform: "translate(-240.843 -109.115)",
    fill: "#c9ccce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68489",
    "data-name": "Path 68489",
    d: "M478.382,204.494v8.365a7.327,7.327,0,0,1-7.319,7.319h-222.9a7.314,7.314,0,0,1-7.319-7.319v-8.365a7.314,7.314,0,0,0,7.319,7.319h222.9A7.327,7.327,0,0,0,478.382,204.494Z",
    transform: "translate(-240.843 -85.49)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4163",
    "data-name": "Line 4163",
    x2: 62.857,
    transform: "translate(113.55 100.898)",
    fill: "none",
    stroke: "#465760",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 11.494,
    cy: 11.494,
    r: 11.494,
    transform: "translate(190.168 88.708)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68490",
    "data-name": "Path 68490",
    d: "M365.344,212.983V218.9H252.5v-5.918a7.314,7.314,0,0,1,7.319-7.319h98.224A7.3,7.3,0,0,1,365.344,212.983Z",
    transform: "translate(-228.12 -84.213)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68491",
    "data-name": "Path 68491",
    d: "M478.382,153.793v46.32a7.314,7.314,0,0,1-7.319,7.319h-93v-5.918c0-4.057-3.546.934-7.583.934H272.261c-4.036,0-7.035-4.991-7.035-.934v5.918H248.162a7.327,7.327,0,0,1-7.319-7.319v-46.32a7.327,7.327,0,0,1,7.319-7.319h222.9A7.314,7.314,0,0,1,478.382,153.793Z",
    transform: "translate(-240.843 -146.474)",
    fill: "#c9ccce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68492",
    "data-name": "Path 68492",
    d: "M478.382,168.124v8.365a7.327,7.327,0,0,1-7.319,7.319h-222.9a7.314,7.314,0,0,1-7.319-7.319v-8.365a7.314,7.314,0,0,0,7.319,7.319h222.9A7.327,7.327,0,0,0,478.382,168.124Z",
    transform: "translate(-240.843 -122.849)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4164",
    "data-name": "Line 4164",
    x2: 62.857,
    transform: "translate(113.55 27.17)",
    fill: "none",
    stroke: "#465760",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_131",
    "data-name": "Ellipse 131",
    cx: 11.494,
    cy: 11.494,
    r: 11.494,
    transform: "translate(190.168 14.979)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68493",
    "data-name": "Path 68493",
    d: "M365.344,176.613v5.918H252.5v-5.918a7.314,7.314,0,0,1,7.319-7.319h98.224A7.3,7.3,0,0,1,365.344,176.613Z",
    transform: "translate(-228.12 -121.573)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68494",
    "data-name": "Path 68494",
    d: "M478.382,226.972v46.32a7.314,7.314,0,0,1-7.319,7.319h-93v-5.918c0-4.057-3.362,0-7.4,0H272.445c-4.036,0-7.219-4.057-7.219,0v5.918H248.162a7.327,7.327,0,0,1-7.319-7.319v-46.32a7.327,7.327,0,0,1,7.319-7.319h222.9A7.314,7.314,0,0,1,478.382,226.972Z",
    transform: "translate(-240.843 -72.828)",
    fill: "#c9ccce"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68495",
    "data-name": "Path 68495",
    d: "M478.382,241.3v8.365a7.327,7.327,0,0,1-7.319,7.319h-222.9a7.314,7.314,0,0,1-7.319-7.319V241.3a7.314,7.314,0,0,0,7.319,7.319h222.9A7.327,7.327,0,0,0,478.382,241.3Z",
    transform: "translate(-240.843 -49.203)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4165",
    "data-name": "Line 4165",
    x2: 62.857,
    transform: "translate(113.55 173.994)",
    fill: "none",
    stroke: "#465760",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_132",
    "data-name": "Ellipse 132",
    cx: 11.494,
    cy: 11.494,
    r: 11.494,
    transform: "translate(190.168 161.804)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68496",
    "data-name": "Path 68496",
    d: "M365.344,249.792v5.918H252.5v-5.918a7.314,7.314,0,0,1,7.319-7.319h98.224A7.3,7.3,0,0,1,365.344,249.792Z",
    transform: "translate(-228.12 -47.927)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4166",
    "data-name": "Line 4166",
    y1: 12.771,
    transform: "translate(24.383 60.958)",
    fill: "none",
    stroke: "#465760",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4167",
    "data-name": "Line 4167",
    y1: 12.771,
    transform: "translate(213.155 60.958)",
    fill: "none",
    stroke: "#465760",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4168",
    "data-name": "Line 4168",
    y1: 12.137,
    transform: "translate(24.383 134.688)",
    fill: "none",
    stroke: "#465760",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4169",
    "data-name": "Line 4169",
    y1: 12.137,
    transform: "translate(213.155 134.688)",
    fill: "none",
    stroke: "#465760",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4170",
    "data-name": "Line 4170",
    y1: 12.691,
    transform: "translate(24.383 207.784)",
    fill: "none",
    stroke: "#465760",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4171",
    "data-name": "Line 4171",
    y1: 12.691,
    transform: "translate(213.155 207.784)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_133",
    "data-name": "Ellipse 133",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(201.076 44.625)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_140",
    "data-name": "Ellipse 140",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(201.076 118.354)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(201.076 191.45)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_134",
    "data-name": "Ellipse 134",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(196.584 44.625)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_139",
    "data-name": "Ellipse 139",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(196.584 118.354)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(196.584 191.45)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(192.093 44.625)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_138",
    "data-name": "Ellipse 138",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(192.093 118.354)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(192.093 191.45)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_136",
    "data-name": "Ellipse 136",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(187.601 44.625)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(187.601 118.354)",
    fill: "#586973"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(187.601 191.45)",
    fill: "#586973"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2509",
    "data-name": "Group 2509",
    transform: "translate(91 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_29",
    "data-name": "Polygon 29",
    d: "M56.926,10.606a7,7,0,0,1,12.149,0L120,99.521A7,7,0,0,1,113.924,110H12.076A7,7,0,0,1,6,99.521Z",
    transform: "translate(714 205)",
    fill: "#bf0b1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_28",
    "data-name": "Polygon 28",
    d: "M54.449,10.4a7,7,0,0,1,12.1,0L114.88,93.48A7,7,0,0,1,108.83,104H12.17A7,7,0,0,1,6.12,93.48Z",
    transform: "translate(716 207)",
    fill: "#f2163e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M7,29.659a3.521,3.521,0,1,1,3.521,3.521A3.521,3.521,0,0,1,7,29.659ZM7.347,8.516a3.186,3.186,0,1,1,6.338,0L12.452,20.864a1.944,1.944,0,0,1-3.873,0Z",
    transform: "translate(766.407 254.005)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 234.245,
    cy: 7.98,
    rx: 234.245,
    ry: 7.98,
    transform: "translate(633.011 602.36)",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2494",
    "data-name": "Group 2494",
    transform: "translate(723.909 371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2493",
    "data-name": "Group 2493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2492",
    "data-name": "Group 2492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2491",
    "data-name": "Group 2491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2490",
    "data-name": "Group 2490"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68524",
    "data-name": "Path 68524",
    d: "M1332.468,465.469H1062.639a8.422,8.422,0,0,0-8.423,8.423V664.477a8.422,8.422,0,0,0,8.423,8.423H1166.2s6.587,20.37-13.835,30.91H1249.2s-23.057-7.9-17.129-30.91h100.4a8.422,8.422,0,0,0,8.423-8.423V473.892A8.422,8.422,0,0,0,1332.468,465.469Z",
    transform: "translate(-1054.216 -465.469)",
    fill: "#586973"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2499",
    "data-name": "Group 2499",
    transform: "translate(861.922 556.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2498",
    "data-name": "Group 2498",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2497",
    "data-name": "Group 2497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2496",
    "data-name": "Group 2496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2495",
    "data-name": "Group 2495"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68525",
    "data-name": "Path 68525",
    d: "M1127.49,553.693c3.67,5.246-2.074,10.99-7.323,7.32a1.874,1.874,0,0,1-.45-.451c-3.659-5.246,2.078-10.984,7.32-7.32A1.841,1.841,0,0,1,1127.49,553.693Z",
    transform: "translate(-1118.561 -552.084)",
    fill: "#c9ccce"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2503",
    "data-name": "Group 2503",
    transform: "translate(725.661 372.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2502",
    "data-name": "Group 2502",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2501",
    "data-name": "Group 2501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1568",
    "data-name": "Rectangle 1568",
    d: "M6.85,0H275.964a6.85,6.85,0,0,1,6.85,6.85V169.073a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6.85A6.85,6.85,0,0,1,6.85,0Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2507",
    "data-name": "Group 2507",
    transform: "translate(782.41 578.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2506",
    "data-name": "Group 2506",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2505",
    "data-name": "Group 2505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68526",
    "data-name": "Path 68526",
    d: "M1253,562.279c0,.088-38.4.161-85.752.161-47.37,0-85.759-.073-85.759-.161s38.389-.163,85.759-.163C1214.6,562.116,1253,562.189,1253,562.279Z",
    transform: "translate(-1081.491 -562.116)",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_145",
    "data-name": "Ellipse 145",
    transform: "translate(750 421)",
    fill: "none",
    stroke: "#586973",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 38.5,
    r: 37.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_4176",
    "data-name": "Line 4176",
    x2: 29.781,
    y2: 29.781,
    transform: "translate(774.635 444.884)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4177",
    "data-name": "Line 4177",
    x1: 29.781,
    y2: 29.781,
    transform: "translate(774.635 444.884)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4101",
    "data-name": "Line 4101",
    x2: 54.374,
    transform: "translate(853.5 417.167)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4102",
    "data-name": "Line 4102",
    x2: 129.164,
    transform: "translate(853.5 453.568)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4103",
    "data-name": "Line 4103",
    x2: 129.164,
    transform: "translate(853.5 477.475)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4104",
    "data-name": "Line 4104",
    x2: 87.246,
    transform: "translate(853.5 501.38)",
    fill: "none",
    stroke: "#586973",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg500Error);
export default __webpack_public_path__ + "static/media/500Error.b2b4e12b.svg";
export { ForwardRef as ReactComponent };